import H2 from "./H2";

export default H2;
